export default __webpack_public_path__ + "static/screen_eth_5-0d2f2443291da1207e3d05ebb12f397d.png";